import { Link } from 'react-router-dom'
import logoImage from '@/assets/logo.png'
import { Facebook, Instagram, Linkedin } from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-black text-white py-12 border-t-2 border-yellow-500 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-gradient-to-br from-yellow-400/5 via-yellow-500/4 to-yellow-600/3 rounded-full blur-2xl animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-gradient-to-br from-yellow-500/10 via-yellow-600/8 to-yellow-700/6 rounded-full blur-xl animate-float" style={{animationDelay: '4s'}}></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="animate-fade-in-up" style={{animationDelay: '0.2s', animationFillMode: 'both'}}>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={logoImage} 
                alt="Sri Sai Sabari Dental Clinic Logo" 
                className="h-10 w-10"
              />
              <h3 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 bg-clip-text text-transparent hover:from-yellow-300 hover:via-yellow-400 hover:to-yellow-500 transition-all duration-300 cursor-pointer">
                Sri Sai Sabari Dental Clinic
              </h3>
            </div>
            <p className="text-gray-300 mb-4 hover:text-gray-200 transition-colors duration-300">
              Providing quality dental care with a gentle touch. Your smile is our priority.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/smile.sssdental" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-yellow-400 transition-all duration-300 transform hover:scale-125 hover:rotate-12 hover:shadow-lg hover:shadow-yellow-400/50"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a 
                href="https://www.instagram.com/sssdentals/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-yellow-400 transition-all duration-300 transform hover:scale-125 hover:rotate-12 hover:shadow-lg hover:shadow-yellow-400/50"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a 
                href="https://www.linkedin.com/in/dr-aishwarya/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-yellow-400 transition-all duration-300 transform hover:scale-125 hover:rotate-12 hover:shadow-lg hover:shadow-yellow-400/50"
              >
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
          </div>
          <div className="animate-fade-in-up" style={{animationDelay: '0.4s', animationFillMode: 'both'}}>
            <h4 className="text-lg font-semibold mb-4 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 bg-clip-text text-transparent">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Home
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/about" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  About Us
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/services" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Services
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/book-appointment" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Book Appointment
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/contact" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Contact
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/privacy-policy" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Privacy Policy
                </Link>
              </li>
              <li className="transform hover:translate-x-2 transition-transform duration-300">
                <Link to="/terms-of-use" className="text-gray-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 relative group">
                  <span className="absolute -left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">→</span>
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>
          <div className="animate-fade-in-up" style={{animationDelay: '0.6s', animationFillMode: 'both'}}>
            <h4 className="text-lg font-semibold mb-4 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 bg-clip-text text-transparent">
              Contact Info
            </h4>
            <div className="space-y-2 text-gray-300">
              <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 cursor-pointer transform hover:scale-105">
                📍 Puzhuthivakkam, Madipakkam, Chennai
              </p>
              <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 cursor-pointer transform hover:scale-105">
                📞 +91-9841817510 / +91-6381823239
              </p>
              <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 cursor-pointer transform hover:scale-105">
                ✉️ smile@sssdental.com
              </p>
              <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 cursor-pointer transform hover:scale-105">
                📅 Open All Days - Because your smile can't wait
              </p>
              <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 cursor-pointer transform hover:scale-105">
                🕒 9 AM - 8:30 PM
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-yellow-600 mt-8 pt-8 text-center text-gray-300 animate-fade-in" style={{animationDelay: '0.8s', animationFillMode: 'both'}}>
          <p className="hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300 mb-2">
            &copy; 2024 Sri Sai Sabari Dental Clinic. All rights reserved.
          </p>
          <p className="text-sm text-gray-400 hover:bg-gradient-to-r hover:from-yellow-400 hover:via-yellow-500 hover:to-yellow-600 hover:bg-clip-text hover:text-transparent transition-all duration-300">
            Website designed and developed by <a href="https://algoshred.com" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-yellow-400 transition-colors duration-300 underline-offset-4 hover:underline">Algoshred Technologies Pvt. Ltd.</a>
          </p>
        </div>
      </div>
    </footer>
  )
}